import {
  RESET_CLIENT_SYSTEM_VARIABLE_VALUES,
  RESET_CLIENT_SYSTEM_VARIABLE_VALUE,
  RESET_ERROR,
  GET_CLIENT_SYSTEM_VARIABLE_VALUES,
  SET_CLIENT_SYSTEM_VARIABLE_VALUES,
  API_ERROR,
  CREATE_CLIENT_SYSTEM_VARIABLE_VALUE,
  CREATE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
  GET_CLIENT_SYSTEM_VARIABLE_VALUE,
  SET_CLIENT_SYSTEM_VARIABLE_VALUE,
  EDIT_CLIENT_SYSTEM_VARIABLE_VALUE,
  EDIT_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
  DELETE_CLIENT_SYSTEM_VARIABLE_VALUE,
  DELETE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorClientSystemVariable: false,
  loadingClientSystemVariable: false,
  dataClientSystemVariable: null,
  successClientSystemVariable: false,
};

const ClientSystemVariables = (state = initialState, action) => {
  switch (action.type) {
    case RESET_CLIENT_SYSTEM_VARIABLE_VALUES:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariable: false,
        loadingClientSystemVariableDelete: false,
        successClientSystemVariable: false,
        dataClientSystemVariable: null,
        dataClientSystemVariableDelete: null,
      };
      break;
    case RESET_CLIENT_SYSTEM_VARIABLE_VALUE:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariable: false,
        successClientSystemVariable: false,
        dataClientSystemVariableGetSet: null,
        dataClientSystemVariableEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariable: false,
        loadingClientSystemVariableEditCreate: false,
        loadingClientSystemVariableActivate: false,
        successClientSystemVariable: false,
      };
      break;   
    case GET_CLIENT_SYSTEM_VARIABLE_VALUES:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariable: true,
        dataClientSystemVariable: null,
      };
      break;
    case SET_CLIENT_SYSTEM_VARIABLE_VALUES:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariable: false,
        dataClientSystemVariable: action.payload,
      };
      break;
    case CREATE_CLIENT_SYSTEM_VARIABLE_VALUE:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariableEditCreate: true,
        dataClientSystemVariableEditCreate: action.payload,
        successClientSystemVariable: false,
      };
      break;
    case CREATE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariableEditCreate: false,
        dataClientSystemVariableEditCreate: action.payload,
        successClientSystemVariable: true,
      };
      break;
    case GET_CLIENT_SYSTEM_VARIABLE_VALUE:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariable: true,
        dataClientSystemVariableGetSet: null,
      };
      break;
    case SET_CLIENT_SYSTEM_VARIABLE_VALUE:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariable: false,
        dataClientSystemVariableGetSet: action.payload,
      };
      break;
    case EDIT_CLIENT_SYSTEM_VARIABLE_VALUE:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariableEditCreate: true,
        dataClientSystemVariableEditCreate: action.payload,
        successClientSystemVariable: false,
      };
      break;
    case EDIT_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariableEditCreate: false,
        dataClientSystemVariableEditCreate: action.payload,
        successClientSystemVariable: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorClientSystemVariable: action.payload,
        loadingClientSystemVariable: false,
        loadingClientSystemVariableDelete: false,
        successClientSystemVariable: false,
      };
      break;
    case DELETE_CLIENT_SYSTEM_VARIABLE_VALUE:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariableDelete: true,
        dataClientSystemVariableDelete: action.payload,
        successClientSystemVariable: false,
      };
      break;
    case DELETE_CLIENT_SYSTEM_VARIABLE_VALUE_SUCCESS:
      state = {
        ...state,
        errorClientSystemVariable: false,
        loadingClientSystemVariableDelete: false,
        dataClientSystemVariableDelete: action.payload,
        successClientSystemVariable: true,
      };
      break;
    default:
      // state = { ...state, errorClientSystemVariable: false, loadingClientSystemVariable: false };
      break;
  }
  return state;
};

export default ClientSystemVariables;
